import { BannerProvider } from '@splunk/olly-common/GettingStartedBanner';
import PropTypes from 'prop-types';
import { AngularInjector } from '../../../common/AngularUtils';
import { ThemeProvider, useLegacyThemeServiceKey } from '../../../common/theme/ThemeProvider';
import { gettingStartedBannerContentDashboards } from './dashboardGSBContent';

export default function DashboardBanner({ currentUser }) {
    const userAnalytics = AngularInjector.useInjectedClass('userAnalytics');
    const themeKey = useLegacyThemeServiceKey();

    return (
        <ThemeProvider colorScheme={themeKey}>
            <BannerProvider
                currentUser={currentUser}
                themeKey={themeKey}
                gettingStartedBannerContent={{
                    ...gettingStartedBannerContentDashboards,
                }}
                userAnalytics={userAnalytics}
                dismissedPillarApiName="sf_uiOnboardingBannerDismissedDashboards"
            />
        </ThemeProvider>
    );
}

DashboardBanner.propTypes = {
    currentUser: PropTypes.object,
};
